import styled from 'styled-components';

export const HomeStyles = styled.div`
.vl1 {
  border-left: 4px solid black;
  height: 100%;
  position: sticky;
  left: 5%;
  margin-left: 5%;
  bottom: 0;

  border-right: 4px solid black;
  height: 100%;
  position: sticky;
  right: 5%;
  margin-right: 5%;
  bottom: 0;
}
`